var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"status-bar",style:({ backgroundColor: _vm.backgroundColor })},[_c('div',{staticClass:"status-container"},[_c('v-icon',{attrs:{"color":_vm.iconColor,"size":_vm.iconSize}},[_vm._v(_vm._s(_vm.icon))]),_c('p',{staticClass:"status-text"},[_vm._v(_vm._s(_vm.statusText))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }